const listeners = new Map()

const on = (event, handler) => {
    if (!listeners.has(event)) {
        listeners.set(event, new Set())
    }
    listeners.get(event).add(handler)
    return () => off(event, handler)
}

const off = (event, handler) => {
    const handlers = listeners.get(event)
    if (!handlers) {
        return
    }
    handlers.delete(handler)
    if (handlers.size === 0) {
        listeners.delete(event)
    }
}

const emit = (event, payload) => {
    const handlers = listeners.get(event)
    if (!handlers) {
        return
    }
    for (const handler of [...handlers]) {
        handler(payload)
    }
}

export default {
    on,
    off,
    emit
}
